import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleLayoutComponent } from './simple-layout/simple-layout.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [SimpleLayoutComponent],
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [SimpleLayoutComponent],
})
export class LayoutModule {}
